import type { RefObject } from 'react';
import { fadeFromTo } from '../../../../util/animation/fade/fade';
import { findTransitionController } from '../../../../util/core-transition-component';

interface SuperpowerSlideRefs {
  titleRef?: RefObject<HTMLHeadingElement | null>;
  titleHolderRef?: RefObject<HTMLDivElement | null>;
  subtitleRef?: RefObject<HTMLHeadingElement | null>;
  subtitleHolderRef?: RefObject<HTMLDivElement | null>;
  backgroundRef?: RefObject<HTMLDivElement | null>;
}

export function setupTransitionInTimeline(
  timeline: gsap.core.Timeline,
  { titleRef, subtitleRef, backgroundRef }: SuperpowerSlideRefs,
): void {
  const titleController = findTransitionController(titleRef);
  const subtitleController = findTransitionController(subtitleRef);

  if (backgroundRef?.current) {
    timeline.add(fadeFromTo(backgroundRef.current), 0);
  }

  if (titleController && subtitleController) {
    timeline.add(titleController.getTimeline('in') as gsap.core.Timeline, 0);
    timeline.add(subtitleController.getTimeline('in') as gsap.core.Timeline, 0);
  }
}

export function setupTransitionOutTimeline(
  timeline: gsap.core.Timeline,
  { titleRef }: SuperpowerSlideRefs,
): void {
  const titleController = findTransitionController(titleRef);

  if (titleController) {
    timeline.add(titleController.getTimeline('out') as gsap.core.Timeline, 0);
  }
}

export function scrollInTimeline(
  timeline: gsap.core.Timeline,
  { titleHolderRef }: SuperpowerSlideRefs,
): void {
  if (titleHolderRef?.current) {
    timeline
      .fromTo(
        titleHolderRef.current,
        {
          transform: 'translate3d(0, 0vh,0)',
        },
        {
          duration: 3,
          ease: 'none',
          transform: 'translate3d(0, -20vh,0)',
        },
      )
      .to(titleHolderRef.current, {
        duration: 0.3,
        ease: 'Power1.easeIn',
        transform: 'translate3d(0, -80vh,0)',
      });
  }
}
